import { css } from '@emotion/css';

export * from '../Procedure.sc';

export const NumberClass = css`
  width: 100%;
`;
